module.exports = __webpack_public_path__ + "img/dxf.ff8c682a.png";